// SPDX-License-Identifier: AGPL-3.0-or-later

export enum HelpCenterArticleSlug {
	AgeVerification = 'age-verification',
	AttachmentExpiry = 'attachment-expiry',
	ChangeDateOfBirth = 'change-date-of-birth',
	TranslateFluxer = 'translate-fluxer',
}
